import { useEffect, useState } from "react";
import { useLocalization } from "@fluent/react";
import { Button, TableAutocomplete } from "@narmi/design_system";

type WireRecipientSelectorProps = {
  rowIndex: number;
  recipients: API.Recipient[];
  onSelectRecipient: (rowIndex: number, recipient: API.Recipient) => void;
  onAddRecipient: (rowIndex: number) => void;
  onEditRecipient: (
    recipientId: API.RecipientId,
    rowIndex: number
  ) => void;
  error?: boolean;
};

const WireRecipientSelector = ({
  rowIndex,
  recipients,
  onSelectRecipient,
  onAddRecipient,
  onEditRecipient,
  error,
}: WireRecipientSelectorProps) => {
  const { l10n } = useLocalization();
  const [inputValue, setInputValue] = useState("");
  const [shouldClear, setShouldClear] = useState(false);

  useEffect(() => {
    if (shouldClear) {
      setInputValue("");
      setShouldClear(false);
    }
  }, [shouldClear]);

  return (
    <TableAutocomplete
      key={rowIndex}
      label={l10n.getString("type-search-label")}
      placeholder={l10n.getString("type-search-label")}
      hasError={error}
      footerContent={
        <Button
          size="s"
          kind="plain"
          onMouseDown={() => {
            onAddRecipient(rowIndex);
          }}
          testId="add-recipient-button"
        >
          <span className="narmi-icon-plus margin--right--xs" />
          {l10n.getString("wire-payments-table-add-recipient")}
        </Button>
      }
      inputValue={inputValue}
      onInputChange={(value: string) => {
        setInputValue(value);
      }}
      onChange={(value: string) => {
        const recipient = recipients.find(
          (r) => r.id === (value as API.RecipientId)
        );
        if (recipient && !recipient.fedwire_destination) {
          // Recipient exists but has no wire details — open edit drawer
          setShouldClear(true);
          onEditRecipient(
            value as API.RecipientId,
            rowIndex
          );
        } else if (recipient) {
          onSelectRecipient(rowIndex, recipient);
          setShouldClear(true);
        }
      }}
    >
      {recipients.map((recipient) => (
        <TableAutocomplete.Item
          key={recipient.id}
          value={recipient.id}
          searchValue={recipient.name}
        >
          {recipient.name}
        </TableAutocomplete.Item>
      ))}
    </TableAutocomplete>
  );
};

export default WireRecipientSelector;
